export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10929.8fe181e3.jpg";